export default "__VITE_ASSET__CgMaY8h6__"